const projects = [
{
  id: 8,
  title: 'Fragrance E-Commerce',
  image: '/photos/perfume.png',
  about: 'Responsive perfume e-commerce landing page, applying prototyping, animation, typography, color theory, and UX principles to create an elegant, conversion-focused user experience.',
  tech: ['Figma','Wireframing','Prototyping'],
  website: 'https://www.figma.com/proto/LoiicwbyZR9YCCRE8aVW1S/Perfume-Design?node-id=2-2&t=8nWSaCnvrRZ8SpNQ-1'
},

  {
    id: 4,
    title: 'ICON-website',
    image: '/photos/Icon_website.png',
    about: 'Company website layout with focus on typography and spacing.',
    tech: ['HTML', 'CSS', 'JavaScript', 'React.js', 'Node.js','React Router DOM', 'React Slick', 'Slick-carousel' ],
    website: 'https://icnepal.com.np/'
  },
  {
    id: 6,
    title: 'Portfolio',
    image: '/photos/Portfolio.png',
    about: 'Current portfolio showcase and Project.',
    tech: ['HTML', 'CSS', 'JavaScript', 'React.js', 'Node.js','React Router DOM'],
    website: 'https://prasannakarmacharya.com.np/'
  },
  {
    id: 1,
    title: 'Dummy Netflix',
    image: '/photos/dummy_Netflix.png',
    about: 'A Netflix-like UI built to browse movies and demos. Focus on responsive layout and card grid.',
    tech: ['HTML', 'CSS', 'JavaScript', 'React.js', "Node.js"],
    website: 'https://mellow-klepon-529b9f.netlify.app/'
  },
  {
    id: 2,
    title: 'Catalog',
    image: '/photos/catalog.png',
    about: 'Product catalog UI with filtering and responsive product grid. Clean cards and interactions.',
    tech: ['HTML', 'SCSS', 'JavaScript'],
    website: 'https://resilient-entremet-982e36.netlify.app/'
  },
  {
    id: 3,
    title: 'Hotel site design',
    image: '/photos/hotel_site_design.png',
    about: 'Hotel site page design for a hotel — hero, booking CTA, gallery and layout.',
    tech: [ 'Figma-Design'],
    website: 'https://www.figma.com/design/zyD0yPQQsvu47z1cFkc8I6/Hotel-add?node-id=0-1&p=f&t=J9dI2eCPCRdqamPc-0'
  },
  
  {
    id: 5,
    title: 'Old Portfolio',
    image: '/photos/old_portfolio.png',
    about: 'Previous portfolio version — archived for reference.',
    tech: ['HTML', 'CSS', 'JavaScript'],
    website: 'https://thunderous-semolina-9e399e.netlify.app/'
  },
   {
  id: 7,
  title: 'Tic-Tac-Toe Game for Multiplayer',
  image: '/photos/game.png',
  about: 'Multiplayer game with utilizing local storage for persistent data, Specific implementation (score tracking)',
  tech: ['HTML', 'CSS', 'JavaScript','Local Storage'],
  website: 'https://resplendent-caramel-630e92.netlify.app/'
},

  
];

export default projects;